import { render, staticRenderFns } from "./lkuObjekpph.vue?vue&type=template&id=4f5dd124"
import script from "./lkuObjekpph.vue?vue&type=script&lang=js"
export * from "./lkuObjekpph.vue?vue&type=script&lang=js"
import style0 from "./lkuObjekpph.vue?vue&type=style&index=0&id=4f5dd124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports